import { createSlice } from '@reduxjs/toolkit'

// Transient UI signals that don't belong to any server cache. favoritePulse is
// a monotonic counter bumped whenever the user saves a listing — the sidebar
// "Вибране" item watches it and plays a one-shot pop so the add is felt in the
// menu too, not only on the card heart (owner feedback).
interface UiState {
  favoritePulse: number
}

const initialState: UiState = {
  favoritePulse: 0,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    pulseFavorite(state) {
      state.favoritePulse += 1
    },
  },
})

export const { pulseFavorite } = uiSlice.actions
export default uiSlice.reducer
